module.exports = __webpack_public_path__ + "static/media/mbari_trophy_room_pic.5fb8e374.jpg";